import { useMeta } from '@nuxtjs/composition-api'

type Seo = {
  title: string
  description: string
  keywords: string
}

export default function setSeo(data: Seo) {
  const { title, meta } = useMeta()
  title.value = data.title
  meta.value = [
    {
      hid: 'description',
      name: 'description',
      content: data.description,
    },
    {
      hid: 'keywords',
      name: 'keywords',
      content: data.keywords,
    },
  ]
}

export function userSeo(data: Seo, uMeta: ReturnType<typeof useMeta>) {
  const { title, meta } = uMeta
  title.value = data.title
  meta.value = [
    {
      hid: 'description',
      name: 'description',
      content: data.description,
    },
    {
      hid: 'keywords',
      name: 'keywords',
      content: data.keywords,
    },
  ]
}
